// export const BASE_URL_API = "https://cors-anywhere.herokuapp.com/https://ltsc.lokaci.com/apis/web";
export const BASE_URL_API = "https://ltsc.lokaci.com/apis/web";